import React from "react";
import { useParams } from "react-router-dom";
import { ChartBarIcon } from "@heroicons/react/24/outline";

function LinkStatsPage() {
  const { id } = useParams();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Link İstatistikleri
        </h1>
        <p className="text-gray-600">Link ID: {id}</p>
      </div>

      <div className="card">
        <div className="card-body text-center py-12">
          <ChartBarIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            İstatistikler Geliştiriliyor
          </h3>
          <p className="text-gray-600">Bu sayfa geliştirilme aşamasındadır</p>
        </div>
      </div>
    </div>
  );
}

export default LinkStatsPage;
